export default __webpack_public_path__ + "static/media/alert-circle-grey.4db3e1f8.svg";